import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom as _fvf } from 'rxjs';
import { IService } from '../interfaces/i.service.interface';
import { DocumentService } from './document.service';

@Injectable({ providedIn: 'root' })
export class VisitorService implements IService {
  _baseUrl: string = 'visitor';
  constructor(
    private http: HttpClient,
    private documentService: DocumentService,
  ) {}

  adClicked(adSlotId: number) {
    return _fvf(
      this.http.post<any>(
        `${this._baseUrl}/ad-clicked`,
        { adSlotId, pageURL: this.documentService.currentPath },
        { params: { isSilent: true } },
      ),
    );
  }
}
